import makeLookup from './makeLookup'

var table = makeLookup('area,base,br,col,command,embed,hr,img,input,keygen,link,meta,param,source,track,wbr')
export default function(closee) {
  return !!table[closee]
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/isSelfCloseing.js